module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_vm._v("THE VETERANS OF A THOUSAND PSYCHIC WARS")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And he was bent on making us feel as he did, and of course his magic accomplished his desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—Mark Twain")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("your magic errandboy’s"), _c('br'), _vm._v("just made a bad guess again")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—Allen Ginsberg")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0